import { render, staticRenderFns } from "./CreatorEditor.vue?vue&type=template&id=0870269c"
import script from "./CreatorEditor.vue?vue&type=script&lang=js"
export * from "./CreatorEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports